
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface PasswordResetDialogsProps {
  username: string | null;
  showConfirmDialog: boolean;
  showResetDialog: boolean;
  newPassword: string;
  onConfirmDialogChange: (open: boolean) => void;
  onResetDialogChange: (open: boolean) => void;
  onPasswordReset: () => void;
  onCopyPassword: () => void;
  onClose: () => void;
}

export function PasswordResetDialogs({
  username,
  showConfirmDialog,
  showResetDialog,
  newPassword,
  onConfirmDialogChange,
  onResetDialogChange,
  onPasswordReset,
  onCopyPassword,
  onClose,
}: PasswordResetDialogsProps) {
  return (
    <>
      <AlertDialog open={showConfirmDialog} onOpenChange={onConfirmDialogChange}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Reset User Password</AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to reset the password for {username || "this user"}? This action cannot be undone.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={onPasswordReset}>
              Reset Password
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <Dialog open={showResetDialog} onOpenChange={onResetDialogChange}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Password Reset Successful</DialogTitle>
            <DialogDescription>
              Here is the new password for {username}. Make sure to securely share it with them.
            </DialogDescription>
          </DialogHeader>
          <div className="flex gap-2">
            <Input value={newPassword} readOnly />
            <Button onClick={onCopyPassword}>
              Copy
            </Button>
          </div>
          <Button 
            variant="secondary" 
            onClick={onClose}
          >
            Close
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
